import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-testimonials',
  templateUrl: './update-testimonials.component.html',
  styleUrls: ['./update-testimonials.component.css']
})
export class UpdateTestimonialsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
